import {type RouteRecordRaw} from "vue-router";

export const TopUp: RouteRecordRaw = {
    path: '/top-up/:service/:originatingSessionId?',
    name: 'topUp',
    component: () => import('./top-up.vue'),
};

export default [
    TopUp
];
